import { IoLeafOutline } from 'react-icons/io5';
import { ImStack } from 'react-icons/im';
import loadingIcon from '../assets/images/loading.svg';

const NodeIcon = ({ node }) => {
  if (node.isLoading) return <img src={loadingIcon} style={{ width: '1rem', height: '1rem' }} alt="Loading" className="mr-2" />;
  if (node.eprflcatId) return <ImStack className="mr-2" />;
  if (node.eprflsrcId) return <IoLeafOutline className="mr-2" />;
};

export default NodeIcon;
